import PropTypes from 'prop-types';

// Utils
import store from "store";

LineItemOptionList.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.object.isRequired // Assuming value is an object with translations
        })
    )
};

function LineItemOptionList({options}) {
    if (!options || options.length === 0) {
        return null;
    }

    const organizationDefaultLocale = store.getState().currentOrganization?.retrieved?.defaultLocale;
    const userLocale = store.getState().authentication?.member?.locale;

    // OptionsTranslations are not used in the LineItem model.
    // The lineItem model's options are in a JSON without relation to the options model
    return options
        .map(option => option.value[userLocale] || option.value[organizationDefaultLocale] || option.value[0])
        .join(' · ');
}

export default LineItemOptionList;
